import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { TrendingUp, ChevronRight } from 'lucide-react';

const headingFont = { fontFamily: "'Outfit', sans-serif" };

/**
 * Upsell modal shown when a user buys a single course (propaganda or digital).
 * Lets them swap to the Combo with a discount, or proceed with the single course
 * (which then routes through the LGPD consent modal).
 */
export function UpsellModal({ upsellModal, onAccept, onDecline, onOpenChange }) {
  const isOpen = upsellModal !== null;
  const isPropaganda = upsellModal === 'propaganda';

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border border-slate-700 text-white w-[calc(100vw-2rem)] max-w-lg" style={{ fontFamily: "'Inter', sans-serif" }}>
        <DialogHeader>
          <div className="w-12 h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center mb-4">
            <TrendingUp className="w-6 h-6 text-amber-400" />
          </div>
          <DialogTitle className="text-xl font-bold text-white" style={headingFont}>
            Espere! Leve a formação completa com desconto exclusivo.
          </DialogTitle>
          <DialogDescription className="text-slate-400 text-sm leading-relaxed mt-2">
            {isPropaganda ? (
              <>Por apenas <strong className="text-white font-semibold">R$ 1.700,00 adicionais</strong>, você leva também o Curso de Direito Digital e IA, recebe certificado total de 40 horas, acesso às aulas gravadas até 31/12 e ao grupo exclusivo de WhatsApp.</>
            ) : (
              <>Por apenas <strong className="text-white font-semibold">R$ 699,00 adicionais</strong>, você leva também o Curso de Propaganda Eleitoral Clássica, recebe certificado total de 40 horas, acesso às aulas gravadas até 31/12 e ao grupo exclusivo de WhatsApp.</>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-5 my-2">
          <div className="flex justify-between items-center text-sm mb-2">
            <span className="text-slate-400">Comprando apenas 1 curso</span>
            <span className="text-slate-300 font-semibold">R$ {isPropaganda ? '999' : '2.000'}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-amber-300 font-bold text-sm">Combo Eleições 2026 (2 cursos)</span>
            <span className="text-amber-400 font-extrabold text-xl">R$ 2.699</span>
          </div>
          <div className="mt-3 pt-3 border-t border-amber-500/20 text-right">
            <p className="text-emerald-400 text-xs font-semibold">Economia de R$ 300,00</p>
          </div>
        </div>

        <div className="flex flex-col gap-3 mt-2">
          <Button data-testid="upsell-accept-btn" onClick={onAccept} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-extrabold py-4 rounded-xl text-base">
            Sim, quero o combo por R$ 2.699,00
          </Button>
          <Button data-testid="upsell-decline-btn" variant="ghost" onClick={onDecline} className="w-full text-slate-400 hover:text-white hover:bg-slate-800 text-sm py-3">
            Não, continuar apenas com {isPropaganda ? 'Propaganda por R$ 999,00' : 'Direito Digital por R$ 2.000,00'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
